import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTestTube2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTestTube2"><Path d="M21 21H13V19H19V14H21V21Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M21.457 9.54297L20.043 10.957L19.25 10.1641L9.95703 19.457C8.46197 20.9519 6.03802 20.9519 4.54297 19.457C3.04808 17.962 3.04808 15.538 4.54297 14.043L13.8359 4.75L13.043 3.95703L14.457 2.54297L21.457 9.54297ZM10.6641 10.75H15.8359L17.8359 8.75L15.25 6.16406L10.6641 10.75Z" fill="currentColor"/><Path d="M10 5H5V11H3V3H10V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTestTube2;
